import { Skeleton } from 'antd';

interface CaseSidebarHeaderProps {
  title: string;
  referenceNumber?: string;
  statusLabel?: string;
  isLoading?: boolean;
}

export function CaseSidebarHeader({ title, referenceNumber, statusLabel, isLoading }: CaseSidebarHeaderProps) {
  return (
    <div className='mb-4 shrink-0 rounded-xl bg-gray-50 px-4 py-3'>
      <Skeleton loading={isLoading} active paragraph={{ rows: 2 }} title={false}>
        <h3 className='my-0 text-sm font-semibold leading-5 text-gray-900'>{title}</h3>
        {referenceNumber && <div className='mt-0.5 text-sm leading-5 text-gray-500'>{referenceNumber}</div>}
        {statusLabel && (
          <div className='mt-2 flex items-center gap-2 text-sm leading-5 text-gray-900'>
            <span className='size-2 shrink-0 rounded-full bg-[#3B82F6]' />
            <span>{statusLabel}</span>
          </div>
        )}
      </Skeleton>
    </div>
  );
}
